<template>
  <div class="leaderboard">
    <div class="card-panel">
      <div class="lb-filters">
        <div class="lb-filters__item">
          <label class="field-label">公司选择</label>
          <el-select
            v-model="lbCompanyId"
            placeholder="全部公司"
            size="medium"
            clearable
            style="width:100%"
            @change="onCompanyChange"
          >
            <el-option
              v-for="co in companyList"
              :key="co.id"
              :label="co.companyName"
              :value="co.id"
            ></el-option>
          </el-select>
        </div>
        <div class="lb-filters__item">
          <label class="field-label">业务子类型</label>
          <el-select
            v-model="lbGroupId"
            placeholder="全部业务"
            size="medium"
            clearable
            :loading="groupLoading"
            :disabled="lbCompanyId == null"
            style="width:100%"
            @change="emitFilterChange"
          >
            <el-option
              v-for="g in groupOptions"
              :key="g.id"
              :label="g.name"
              :value="g.id"
            ></el-option>
          </el-select>
        </div>
        <div class="lb-filters__item">
          <label class="field-label">时间间隔</label>
          <el-select v-model="lbTimeRange" size="medium" style="width:100%" @change="emitFilterChange">
            <el-option label="今天" :value="0"></el-option>
            <el-option label="近7天" :value="7"></el-option>
            <el-option label="近30天" :value="30"></el-option>
            <el-option label="近90天" :value="90"></el-option>
            <el-option label="近180天" :value="180"></el-option>
            <el-option label="近1年" :value="365"></el-option>
          </el-select>
        </div>
        <div class="lb-filters__item lb-filters__item--action">
          <label class="field-label" style="visibility:hidden">占位</label>
          <el-button type="warning" icon="el-icon-search" @click="emitFilterChange">查询</el-button>
        </div>
      </div>

      <div class="lb-stats">
        <div class="lb-stats__item">
          <div class="lb-stats__label">总触发次数</div>
          <div class="lb-stats__value">{{ statsTotal.toLocaleString() }}</div>
        </div>
        <div class="lb-stats__item">
          <div class="lb-stats__label">涉及标签数</div>
          <div class="lb-stats__value">{{ statsTagCount }}</div>
        </div>
        <div class="lb-stats__item">
          <div class="lb-stats__label">覆盖业务池</div>
          <div class="lb-stats__value">{{ statsPoolCount }}</div>
        </div>
      </div>
    </div>

    <div class="lb-content">
      <div class="lb-table-panel">
        <div class="lb-table-panel__header">
          <h3 class="lb-table-panel__title">
            <i class="el-icon-data-line" style="color:#e6a23c"></i>
            实时触发排行榜
          </h3>
          <span class="lb-table-panel__time">最后更新：{{ lastUpdateTime }}</span>
        </div>

        <div class="lb-table-body" v-loading="loading" v-if="pageData.length > 0">
          <div
            v-for="(item, idx) in pageData"
            :key="idx"
            class="lb-row"
          >
            <div class="lb-row__rank">
              <span v-if="rankNumber(idx) === 1">1</span>
              <span v-else-if="rankNumber(idx) === 2">2</span>
              <span v-else-if="rankNumber(idx) === 3">3</span>
              <span v-else>{{ rankNumber(idx) }}</span>
            </div>
            <div class="lb-row__info">
              <div class="lb-row__name">{{ item.tagName }}</div>
            </div>
            <div class="lb-row__count">
              <div class="lb-row__count-num">{{ item.count.toLocaleString() }}</div>
              <div class="lb-row__count-label">触发次数</div>
            </div>
            <div class="lb-row__trend" :class="`lb-row__trend--${item.trend}`">
              <i :class="trendIcon(item.trend)"></i>
              <span>{{ Number(item.change) > 0 ? '+' : '' }}{{ item.change }}%</span>
              <div class="lb-row__trend-label">环比趋势</div>
            </div>
          </div>
        </div>
        <div v-else class="lb-table-empty">
          <i class="el-icon-inbox" style="font-size:48px;color:#e8e8e8"></i>
          <p>暂无排行榜数据</p>
        </div>

        <div class="lb-table-footer" v-if="totalPages > 0">
          <span>共 <b>{{ rows.length }}</b> 条记录</span>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="rows.length"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            @current-change="onPageChange"
          ></el-pagination>
          <span></span>
        </div>
      </div>

      <div class="lb-pie-panel">
        <div class="card-panel" style="margin-bottom:0">
          <h3 class="lb-pie-title">
            <i class="el-icon-pie-chart" style="color:#e6a23c"></i>
            触发次数 Top20 占比分布
          </h3>
          <div class="lb-pie-chart">
            <canvas ref="pieCanvas" width="300" height="300"></canvas>
            <div class="lb-pie-center">
              <div class="lb-pie-center__num">Top 20</div>
              <div class="lb-pie-center__label">分布比例</div>
            </div>
          </div>
          <div class="lb-pie-legend">
            <div
              v-for="(item, idx) in pieLegend"
              :key="idx"
              class="lb-pie-legend__item"
            >
              <div class="lb-pie-legend__color" :style="{ background: item.color }"></div>
              <span class="lb-pie-legend__name">{{ item.name }}</span>
              <span class="lb-pie-legend__percent">{{ item.percent }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PIE_COLORS = [
  '#FF6B35', '#FF8C42', '#FFA559', '#FFB74D', '#FFC107',
  '#FFD54F', '#FFE082', '#FFECB3', '#FFF8E1', '#FFFDE7',
  '#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A',
  '#4CAF50', '#43A047', '#388E3C', '#2E7D32', '#1B5E20'
];

export default {
  name: 'Leaderboard',
  props: {
    // { rowList: [{ tagName, count, change, trend }], groupCount }
    leaderboardData: {
      type: Object,
      default: () => ({ rowList: [], groupCount: 0 })
    },
    companyList: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      // 公司 id，null 表示全部公司
      lbCompanyId: null,
      // 策略组 id，null 表示全部业务
      lbGroupId: null,
      // 查看 days 天前的数据，0 为当天
      lbTimeRange: 0,
      groupOptions: [],
      groupLoading: false,
      currentPage: 1,
      pageSize: 10,
      lastUpdateTime: '—',
      piePaths: []
    };
  },
  computed: {
    // 排行榜数据按触发次数倒序，作为表格 / 分页 / 饼图的唯一数据源
    rows() {
      return (this.leaderboardData.rowList || []).slice().sort((a, b) => b.count - a.count);
    },
    statsTotal() {
      return this.rows.reduce((sum, item) => sum + item.count, 0);
    },
    statsTagCount() {
      return this.rows.length;
    },
    // 覆盖业务池个数直接取接口返回的 groupCount（涉及策略组个数）
    statsPoolCount() {
      return Number(this.leaderboardData.groupCount) || 0;
    },
    totalPages() {
      return Math.ceil(this.rows.length / this.pageSize);
    },
    pageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.rows.slice(start, start + this.pageSize);
    },
    top20() {
      return this.rows.slice(0, 20);
    },
    pieLegend() {
      const top20 = this.top20;
      const total = this.statsTotal;
      const display = 10;
      const result = top20.slice(0, display).map((item, i) => ({
        name: item.tagName,
        color: PIE_COLORS[i],
        percent: total > 0 ? ((item.count / total) * 100).toFixed(1) : '0.0'
      }));
      const otherCount = top20.slice(display).reduce((sum, item) => sum + item.count, 0);
      if (otherCount > 0) {
        result.push({
          name: `其他 (${top20.slice(display).length}项)`,
          color: '#e2e8f0',
          percent: total > 0 ? ((otherCount / total) * 100).toFixed(1) : '0.0'
        });
      }
      return result;
    }
  },
  watch: {
    // 父级拉取到新排行榜数据后：回到第一页、刷新时间并重绘饼图
    leaderboardData: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.lastUpdateTime = new Date().toLocaleString();
        this.$nextTick(() => {
          this.drawPieChart();
        });
      }
    }
  },
  methods: {
    rankNumber(idx) {
      return ((this.currentPage - 1) * this.pageSize) + idx + 1;
    },
    trendIcon(trend) {
      if (trend === 'up') return 'el-icon-top';
      if (trend === 'down') return 'el-icon-bottom';
      return 'el-icon-minus';
    },
    // 筛选条件交由父级统一请求 /scene/rankingList
    emitFilterChange() {
      this.$emit('filter-change', {
        companyId: this.lbCompanyId,
        groupId: this.lbGroupId,
        days: this.lbTimeRange
      });
    },
    onCompanyChange() {
      // 策略组依赖公司，切换公司后原选择的策略组失效
      this.lbGroupId = null;
      this.loadGroups();
      this.emitFilterChange();
    },
    // 策略组下拉：/strategy/selectAllGroupsByCompanyIdOfUser，按公司查询
    loadGroups() {
      if (this.lbCompanyId == null || this.lbCompanyId === undefined || this.lbCompanyId === '') {
        this.groupOptions = [];
        return;
      }
      this.groupLoading = true;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: { companyId: this.lbCompanyId }
      })
        .then((res) => {
          this.groupLoading = false;
          this.groupOptions = (res.data || []).map(g => ({
            id: g.id,
            name: g.groupName || ''
          }));
        })
        .catch(() => {
          this.groupLoading = false;
          this.groupOptions = [];
        });
    },
    onPageChange() {},
    drawPieChart() {
      const canvas = this.$refs.pieCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const cx = canvas.width / 2;
      const cy = canvas.height / 2;
      const outerR = 120;
      const innerR = 70;

      const top20 = this.top20;
      const total = this.statsTotal;
      if (total === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.piePaths = [];

      let currentAngle = -0.5 * Math.PI;
      top20.forEach((item, i) => {
        const sliceAngle = (item.count / total) * 2 * Math.PI;
        const path = new Path2D();
        path.moveTo(cx + (innerR * Math.cos(currentAngle)), cy + (innerR * Math.sin(currentAngle)));
        path.arc(cx, cy, outerR, currentAngle, currentAngle + sliceAngle);
        path.arc(cx, cy, innerR, currentAngle + sliceAngle, currentAngle, true);
        path.closePath();

        ctx.fillStyle = PIE_COLORS[i % PIE_COLORS.length];
        ctx.fill(path);
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke(path);

        this.piePaths.push({
          path,
          item,
          startAngle: currentAngle,
          endAngle: currentAngle + sliceAngle,
          color: PIE_COLORS[i % PIE_COLORS.length],
          percent: ((item.count / total) * 100).toFixed(1)
        });
        currentAngle += sliceAngle;
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/style/variable.less';

.card-panel {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.field-label {
  font-size: 12px;
  font-weight: bold;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: block;
  margin-bottom: 8px;
}

.lb-filters {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;

  &__item {
    width: 220px;

    &--action {
      width: auto;
    }
  }
}

.lb-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #f0f0f0;

  &__item {
    text-align: center;
  }

  &__label {
    font-size: 12px;
    color: #c0c4cc;
    font-weight: bold;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 24px;
    font-weight: bold;
    color: #303133;
  }
}

.lb-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.lb-table-panel {
  width: 60%;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin: 0;
  }

  &__time {
    font-size: 12px;
    color: #c0c4cc;
  }
}

.lb-table-body {
  min-height: 400px;
}

.lb-row {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #fafafa;
  transition: background 0.2s;

  &:hover {
    background: #fafafa;
  }

  &__rank {
    width: 48px;
    font-size: 22px;
    font-weight: 900;
    color: #c0c4cc;
    text-align: center;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-weight: bold;
    color: #303133;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 2px;
  }


  &__count {
    width: 120px;
    text-align: right;
    padding: 0 16px;
  }

  &__count-num {
    font-size: 18px;
    font-weight: 900;
    background: linear-gradient(to right, #e6a23c, #f56c6c);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__count-label {
    font-size: 10px;
    color: #c0c4cc;
  }

  &__trend {
    width: 80px;
    text-align: right;
    font-weight: bold;
    font-size: 13px;

    &--up {
      color: #67c23a;
    }

    &--down {
      color: #f56c6c;
    }

    &--flat {
      color: #c0c4cc;
    }
  }

  &__trend-label {
    font-size: 10px;
    color: #c0c4cc;
    font-weight: normal;
  }
}

.lb-table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #c0c4cc;
}

.lb-table-footer {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 12px 20px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
  color: #909399;
}

.lb-pie-panel {
  width: 40%;
}

.lb-pie-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 20px;
}

.lb-pie-chart {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 16px 0;
}

.lb-pie-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;

  &__num {
    font-size: 20px;
    font-weight: 900;
    color: #303133;
  }

  &__label {
    font-size: 10px;
    color: #c0c4cc;
    font-weight: bold;
  }
}

.lb-pie-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-top: 20px;

  &__item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
  }

  &__color {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    flex-shrink: 0;
  }

  &__name {
    color: #606266;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__percent {
    color: #c0c4cc;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/tagpools/leaderboard.vue